import createIcon from '../../createIcon';

/**
 * @component @name LinkedCamera
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTcuMkMxMy43NjczIDE3LjIgMTUuMiAxNS43NjczIDE1LjIgMTRDMTUuMiAxMi4yMzI3IDEzLjc2NzMgMTAuOCAxMiAxMC44QzEwLjIzMjcgMTAuOCA4LjggMTIuMjMyNyA4LjggMTRDOC44IDE1Ljc2NzMgMTAuMjMyNyAxNy4yIDEyIDE3LjJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTYgMy4zM0MxOC41OCAzLjMzIDIwLjY3IDUuNDIgMjAuNjcgOEgyMkMyMiA0LjY5IDE5LjMxIDIgMTYgMlYzLjMzWk0xNiA2QzE3LjExIDYgMTggNi44OSAxOCA4SDE5LjMzQzE5LjMzIDYuMTYgMTcuODQgNC42NyAxNiA0LjY3VjZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcgOUMxNyA3Ljg5IDE2LjExIDcgMTUgN1Y0SDlMNy4xNyA2SDRDMi45IDYgMiA2LjkgMiA4VjIwQzIgMjEuMSAyLjkgMjIgNCAyMkgyMEMyMS4xIDIyIDIyIDIxLjEgMjIgMjBWOUgxN1pNMTIgMTlDOS4yNCAxOSA3IDE2Ljc2IDcgMTRDNyAxMS4yNCA5LjI0IDkgMTIgOUMxNC43NiA5IDE3IDExLjI0IDE3IDE0QzE3IDE2Ljc2IDE0Ljc2IDE5IDEyIDE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LinkedCamera = createIcon('LinkedCamera', [
  [
    'path',
    {
      d: 'M12 17.2C13.7673 17.2 15.2 15.7673 15.2 14C15.2 12.2327 13.7673 10.8 12 10.8C10.2327 10.8 8.8 12.2327 8.8 14C8.8 15.7673 10.2327 17.2 12 17.2Z',
      key: 'uar2a9',
    },
  ],
  [
    'path',
    {
      d: 'M16 3.33C18.58 3.33 20.67 5.42 20.67 8H22C22 4.69 19.31 2 16 2V3.33ZM16 6C17.11 6 18 6.89 18 8H19.33C19.33 6.16 17.84 4.67 16 4.67V6Z',
      key: 'xwiher',
    },
  ],
  [
    'path',
    {
      d: 'M17 9C17 7.89 16.11 7 15 7V4H9L7.17 6H4C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V9H17ZM12 19C9.24 19 7 16.76 7 14C7 11.24 9.24 9 12 9C14.76 9 17 11.24 17 14C17 16.76 14.76 19 12 19Z',
      key: 'njzjxd',
    },
  ],
]);

export default LinkedCamera;
